// tasks.ts — contractor task list (EGO-132 Phase A). Active tasks straight
// from the store under RLS (authenticated read of status='active'), done
// counts from the caller's own completed sessions (RLS self-read) grouped by
// the task_id stamped at upload. Pure render — no device involvement.
import { supabase } from "./auth.ts";

const esc = (s: unknown) => String(s).replace(/[&<>"']/g, (c) =>
  ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]!));

export async function renderTasks(): Promise<void> {
  const box = document.getElementById("taskList");
  if (!box) return;
  const [tasksRes, sessRes] = await Promise.all([
    supabase.from("tasks").select("id,slug,name,subtasks,target_count")
      .eq("status", "active").order("created_at"),
    supabase.from("sessions").select("task_id").eq("status", "complete"),
  ]);
  if (tasksRes.error) {
    box.innerHTML = `<span class="mutedSm">Couldn't load tasks: ${esc(tasksRes.error.message)}</span>`;
    return;
  }
  const counts = new Map<string, number>();
  for (const s of sessRes.data ?? []) {
    if (s.task_id) counts.set(s.task_id, (counts.get(s.task_id) ?? 0) + 1);
  }
  const tasks = tasksRes.data ?? [];
  if (!tasks.length) {
    box.innerHTML = `<span class="mutedSm">No tasks assigned right now — check back soon.</span>`;
    return;
  }
  box.innerHTML = tasks.map((t: any) => {
    const done = counts.get(t.id) ?? 0;
    const target: number | null = t.target_count ?? null;
    const pct = target ? Math.min(100, Math.round((done / target) * 100)) : 0;
    const steps = ((t.subtasks as string[]) ?? []).map((s) => `<li>${esc(s)}</li>`).join("");
    return `
      <details class="task">
        <summary>
          <b>${esc(t.name)}</b>
          <span class="tcount">${done}${target ? ` / ${target}` : ""} captured</span>
        </summary>
        ${target ? `<div class="meter"><i style="width:${pct}%"></i></div>` : ""}
        <ol class="tsteps">${steps}</ol>
      </details>`;
  }).join("");
}
